import PropTypes from 'prop-types'
import { Component } from 'react'

const getSubdomainsAndHostname = () => {
  const hostname = window.location.hostname

  if (hostname.includes('localhost')) {
    return {
      hostnameWithoutSubdomains: 'localhost',
      subdomains: hostname.split('.').filter(x => x !== 'localhost'),
    }
  }

  const subdomains = hostname.split('.')
  const tld = subdomains.pop()
  const domain = subdomains.pop()

  return {
    hostnameWithoutSubdomains: `${domain}.${tld}`,
    subdomains,
  }
}

export class SubdomainSanitizer extends Component {
  static propTypes = {
    children: PropTypes.any,
  }

  state = {
    didCheck: false,
  }

  componentDidMount() {
    const { hostnameWithoutSubdomains, subdomains } = getSubdomainsAndHostname()

    const currentUrl = window.location.href

    // Build new url with clean hostname & map the broker name as a subdomain to a query param
    const newUrl = new URL(currentUrl)

    // Keep environment subdomain prefix
    const envSubdomainPrefix = subdomains.find(x => ['dev', 'staging', 'demo'].includes(x))
    newUrl.hostname = envSubdomainPrefix
      ? `${envSubdomainPrefix}.${hostnameWithoutSubdomains}`
      : hostnameWithoutSubdomains

    const brokerNameSubdomain = subdomains.find(x => !['www', 'dev', 'staging', 'demo'].includes(x))
    if (brokerNameSubdomain) {
      newUrl.searchParams.set('subdomain', brokerNameSubdomain)
    }

    // TODO: Remove on production after testing
    console.log('Debug info', { hostnameWithoutSubdomains, subdomains, envSubdomainPrefix, brokerNameSubdomain })

    if (newUrl.href !== currentUrl) {
      console.log(`Redirecting to ${newUrl.href} from ${currentUrl}`)
      window.location.assign(newUrl.href)
      return
    }

    console.log('No redirect needed')

    this.setState({ didCheck: true })
  }

  render() {
    return this.state.didCheck ? this.props.children : null
  }
}



// WEBPACK FOOTER //
// ./src/SubdomainSanitizer.js